import React from 'react'
import { ImageLink, Props } from 'component-library/buttons/ImageLink'
import { createRegisterableComponent } from 'common/routing/page-definition'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ImageLinkRouteProps extends Props {}

export const ImageLinkRegistration = createRegisterableComponent(
    'image-link',
    (props: ImageLinkRouteProps) => <ImageLink {...props} />
)
